<template>

  <ComponentTemplate />

</template>

<script>
import ComponentTemplate from '../components/pratiche/PrezzoAcquisto.vue'

export default {
  components: {
    ComponentTemplate

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
